class CancelUploadError extends Error {
    constructor(...params) {
        // Pass arguments to parent constructor
        super(...params);

        // Maintain proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
        Error.captureStackTrace(this, CancelUploadError);
        }

        this.name = 'CancelUploadError';
        this.code = "CANCELLED";
    }
}

module.exports = CancelUploadError;
